export const getToggleHeightButton = ({ isXXLWidth, workers, equipment }) => {
  if (isXXLWidth) return workers.length > 3 || equipment.length > 3;
  return workers.length + equipment.length > 3;
};
